module.exports = __webpack_public_path__ + "img/singleProduct.5df02cc9.jpg";